import * as React from 'react';

export const PREMIUM_CALL_OUT_TITLE = 'See Every Student’s Progress as It Happens';

export interface SchoolAdmin {
  name?: string,
  email?: string,
}

// As in the Skills Report; addressed only when the school has one admin
export const adminContactMailto = (schoolAdmins?: SchoolAdmin[]|null) => {
  const subject = "Can you help unlock Quill's full Live View?";
  const toEmail = schoolAdmins?.length === 1 ? schoolAdmins[0].email || '' : '';
  const body = `Hi there,

I've been using Quill's new Live View, which shows me which of my students are online and how long they've spent on their activity. With a School or District Premium plan, it can do even more, like showing each student's progress question by question as they work, and flagging the students who have missed several questions or have been stuck on one for a long time.

That would make it much easier to see who needs my help while they're still working, instead of after the activity is over. You can see the full list of Premium features here: https://www.quill.org/premium

If you'd like to learn more or explore pricing options, you can fill out this short form to connect with Quill's Partnerships Team: https://quillorg.salesmate.io/webforms/#/5d6a5b51-8ed9-49d5-923e-dcab1baa0063

Thanks for considering it!`;

  return `mailto:${toEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

const PremiumCallOut = ({ schoolAdmins }: { schoolAdmins?: SchoolAdmin[]|null }) => (
  <section aria-labelledby="live-view-premium-call-out-title" className="live-view-premium-call-out">
    <h2 id="live-view-premium-call-out-title">{PREMIUM_CALL_OUT_TITLE}</h2>
    <p>With Live View, see who may need your support while they&rsquo;re still working.</p>
    <p>Every Quill teacher, without a subscription, can see which students are online and how long they&rsquo;ve spent on their activities.</p>
    <p><b>Upgrading to a School or District Premium plan unlocks the full power of this report.</b> You&rsquo;ll see every student&rsquo;s progress on each question, which questions they answered incorrectly, and who has spent a long time on one question, so you can step in to help before the activity is over.</p>
    <div className="buttons-wrapper">
      <a className="quill-button green outlined medium focus-on-light" href="/premium" rel="noopener noreferrer" target="_blank">
        Learn more about School &amp; District Premium
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
      <a className="quill-button green contained medium focus-on-light" href={adminContactMailto(schoolAdmins)}>Contact your admin</a>
    </div>
  </section>
);

export default PremiumCallOut;
